<!--
 * @Author: 牛字杰 niuzijie@.jtexpress
 * @Date: 2022-07-18 10:31:50
 * @LastEditors: niuzijie
 * @LastEditTime: 2024-03-11 18:03:51
 * @FilePath: \yl-wxcx-coupon-front\src\views\coupon.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="coupon-page">
    <div class="banner" :style="{backgroundImage: 'url(' + bannerImg + ')'}"></div>
    <div class="grab-coupon" :style="{backgroundImage: 'url(' + couponImage + ')'}">
      <img @click="grabCoupon" src="@/assets/img/coupon/grab.png" alt="">
    </div>
    <div class="use-details" :style="{backgroundImage: 'url(' + useDetailsImage + ')'}">
      <div class="footer">
        <img @click="focusPublic" src="@/assets/img/coupon/thePublic.png" alt="">
        <img @click="shippingChannel" src="@/assets/img/coupon/sendShip.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { coupon, receiveBenefit } from '@/api'
import { loadScript } from '@/utils/loadScript.js'
import wx from 'weixin-js-sdk'
export default {
  name: 'Coupon',
  data() {
    return {
      bannerImg: '',
      couponImage: '',
      useDetailsImage: '',
    }
  },
  created() {
    this.getImgList(93)
    this.getImgList(92)
    this.getImgList(91)
  },
  async mounted() {
    await loadScript('https://h5.bestpay.cn/common/js/bestpay-html5-3.0.js')
    // eslint-disable-next-line no-undef
    BestpayHtml5.config()
  },
  methods: {
    // 授权并领取优惠券
    async grabCoupon () {
      // eslint-disable-next-line no-undef
      BestpayHtml5.User.userAuth(
        {
          scope: 'mobile',
          clientId: '86000000344', // 第三方应用编号
          redirectUrl: 'https://coupon.jtexpress.com.cn/coupon', // 回调地址,必须和申请应用是填写对一致
          merchantCode: '3178037000697784', // 商户号
          state: 'couponPageIndex',
        },
        async (result) => { // 成功回调
          try {
            const params = {
              code: result.code,
              grantType: result.grantType,
            }
            const res = await coupon.getCoupon(params)
            if (res.code === 1 && res.data) {
              this.$router.push('/grabSuccess')
            } else if (res.code === 1 && !res.data) {
              this.$router.push('/menerima')
            } else {
              this.$toast.fail({
                message: res.msg,
                duration: 2000,
              })
            }
          } catch (err) { console.log(err, 'err+++++++++++') }
          // TODO: coding for business
        },
        (err) => {
          console.log(err, '失败回调, err+++++++++++')
        }, // 失败回调
        () => {
          console.log('取消回调+++++++++++++++')
        } // 取消回调
      )
    },
    // 获取配置图片
    async getImgList(type) {
      const params = {
        type,
      }
      const { code, data } = await receiveBenefit.getImgList(params)
      if (code === 1) {
        switch (type) {
          case 93:
            this.bannerImg = data && data[0].imageUrl
            break
          case 92:
            this.couponImage = data && data[0].imageUrl
            break
          case 91:
            this.useDetailsImage = data && data[0].imageUrl
            break
          default:
            break
        }
      }
    },
    // 跳转微信公众号
    focusPublic() {
      window.location.href = 'https://mp.weixin.qq.com/s/AvXKpBG9kVYtqNKlFT4UAQ'
    },
    // 寄件通道
    async shippingChannel() {
      if (this.isWx()) {
        const url = 'pages/sendGoods/sendGoods'
        wx.miniProgram.navigateTo({
          url: `/package/pages/transfer/index?appid=wxe37801988179d0a5&path=${encodeURIComponent(url)}`,
          success: async function(res) {
            console.log(res, 'res++++++++++++++++++++++++')
          },
          fail: function(error) {
            console.log(error, 'error++++++++++++++++++++++++++')
          },
        })
      } else {
        const schemeLink = this.getCookie('sendGooodsPage')
        schemeLink ? window.location.href = schemeLink : this.getScheme()
      }
    },
    // 请求小程序链接
    async getScheme() {
      const path = 'pages/sendGoods/sendGoods'
      const { code, msg, data } = await coupon.getSchemeUrl(path)
      if (code === 1) {
        // cookie缓存schemeLink， 期限29天
        this.$cookie.set('sendGooodsPage', data, { expires: 29 })
        window.location.href = data // 页面重定向新的地址
      } else {
        alert(msg)
      }
    },
    // 获取cookie
    getCookie(key = 'sendGooodsPage') {
      return this.$cookie.get(key)
    },
    // 判断是否为微信环境
    isWx() {
      // 是否电脑微信或者微信开发者工具企业微信
      return /(micromessenger)/i.test(navigator.userAgent)
    },
  },
}
</script>

<style lang="scss" scoped>
.coupon-page {
  .banner {
    width: 100%;
    height: 970rpx;
    background-image: url('../../assets/img/coupon/banner.png');
    background-size: 100% 100%;
  }
  .grab-coupon {
    width: 100%;
    height: 1133rpx;
    background-image: url('../../assets/img/coupon/coupon-num.png');
    background-size: 100% 100%;
    position: relative;
    img {
      position: absolute;
      top: 80rpx;
      right: 0;
      width: 232rpx;
      height: 430rpx;
      cursor: pointer;
    }
  }
  .use-details {
    width: 100%;
    height: 1847rpx;
    background-image: url('../../assets/img/coupon/use-details.png');
    background-size: 100% 100%;
    position: relative;

    .footer {
      width: 100%;
      position: absolute;
      bottom: 107rpx;
      // left: 20rpx;
      display: flex;
      justify-content: space-between;
      padding: 0 35rpx;
      img {
        width: 320rpx;
        height: 163rpx;
      }
    }
  }
}
</style>
